import styled from 'styled-components'
import { theme } from './../../common'

export const CardWrapper = styled.div`
    background-color: ${theme.lightGrey};
    border-top: 3px solid ${theme.primary};
    flex: 1;
    height: 100%;
    padding: 0 7%;
    padding-bottom: 5%;
    @media screen and (max-width: 992px) {
        margin: 10px 0px;
        padding: 5% 7%;
    }
`
export const CardHeader = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 250px;
    @media screen and (max-width: 992px) {
        min-height: 0;
    }
    img {
        max-width: 150px;
        width: 100%;
        height: auto;

        @media screen and (max-width: 992px) {
            max-width: 100px;
        }
    }
`
export const StyledTitle = styled.h2`
    text-transform: uppercase;
    font-weight: bold;
    font-size: 2em;
    max-width: 200px;
    margin: 5% 0;
`
export const StyledContent = styled.div`
    p { margin: 0px; }
`